/**
* @author 贝才[beica1@outook.com]
* @date 2021/3/11
* @description
*   DialogTemplate.vue of WeTrade
*/
<template>
<div class="px-30">
  <template v-if="!noTitle">
    <div class="t-center d-title f-bold f-lg df-middle df-between">
      <div class="d-left df-middle">
        <slot name="left" />
        <slot name="title">Dialog Title</slot>
      </div>
      <span class="close-wrap">
        <slot name="right" />
      </span>
    </div>
    <Line />
  </template>
  <div class="dialog__body df-middle">
    <slot />
  </div>
  <div class="dialog__controls f-medium py-20 t-right">
    <slot name="controls">
      <slot name="cancel">
        <button class="btn line" @click="cancel">
          <slot name="cancelText">
            <t path="withdrawal_30" #="{td}" custom>{{td || 'Cancel'}}</t>
          </slot>
        </button>
      </slot>
      <slot name="confirm">
        <button class="btn primary" @click="confirm">
          <slot name="confirmText">
            <t path="withdrawal_31" #="{td}" custom>{{td || 'Confirm'}}</t>
          </slot>
        </button>
      </slot>
    </slot>
  </div>
</div>
</template>

<script lang="ts">
import Line from '@/components/Line.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogTemplate',
  components: { Line },
  props: {
    noTitle: Boolean,
  },
  setup (props, ctx) {
    return {
      cancel () {
        ctx.emit('cancel')
        ctx.emit('close')
      },
      confirm () {
        ctx.emit('confirm')
        ctx.emit('close')
      },
    }
  },
})
</script>

<style scoped lang="scss">
.dialog__body {
  min-height: 100px;
}

.d-title {
  min-height: 50px;
}

::v-deep(.dialog__controls .btn) {
  min-width: 100px;
  cursor: pointer;
  border-radius: 6px;

  &:not(:first-child) {
    margin-left: 10px;
  }
}

.close-wrap {
  cursor: pointer;
}
</style>
